// extracted by mini-css-extract-plugin
module.exports = {"container":"floatingMenu_container__x_EgL","content":"floatingMenu_content__fOmSQ"};